import React from "react";
import { Box } from "@material-ui/core";

export const PROGRESS_KEYS = ["P", "WA", "WI", "M"];

export const PROGRESS_KEY_COLORS = {
  P: "#1a9b54",
  WA: "#1769d6",
  WI: "#7c4dff",
  M: "#d4a017",
};

const INCOMPLETE_BORDER = "#c5cdd8";
const INCOMPLETE_TEXT = "#8b95a5";

export const normalizeProgressValue = (value) => {
  if (!value || value === false) return "";
  if (value === true) return "M";
  const key = String(value).trim().toUpperCase();
  return PROGRESS_KEYS.includes(key) ? key : "";
};

const getProgressIndex = (value) => {
  const normalized = normalizeProgressValue(value);
  if (!normalized) return -1;
  return PROGRESS_KEYS.indexOf(normalized);
};

const ProgressKeyButtons = ({ value, onChange, disabled = false }) => {
  const selected = normalizeProgressValue(value);
  const currentIndex = getProgressIndex(value);

  return (
    <Box display="inline-flex" alignItems="center" style={{ gap: 2, flexWrap: "nowrap" }}>
      {PROGRESS_KEYS.map((key, stepIndex) => {
        const color = PROGRESS_KEY_COLORS[key];
        const isWide = key.length > 1;
        const isCurrent = selected === key;
        const isDone = currentIndex >= 0 && stepIndex < currentIndex;
        const isComplete = isDone || isCurrent;

        return (
          <button
            key={key}
            type="button"
            disabled={disabled}
            onClick={() => onChange(isCurrent ? "" : key)}
            aria-label={key}
            aria-pressed={isComplete}
            title={key}
            style={{
              width: isWide ? 22 : 18,
              height: 18,
              minWidth: isWide ? 22 : 18,
              padding: 0,
              borderRadius: 999,
              border: `1.5px solid ${isComplete ? color : INCOMPLETE_BORDER}`,
              backgroundColor: isComplete ? color : "#fff",
              color: isComplete ? "#fff" : INCOMPLETE_TEXT,
              fontSize: isWide ? "0.48rem" : "0.55rem",
              fontWeight: 700,
              lineHeight: 1,
              cursor: disabled ? "default" : "pointer",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              opacity: disabled ? 0.6 : 1,
            }}
          >
            {key}
          </button>
        );
      })}
    </Box>
  );
};

export default ProgressKeyButtons;
